export default function toPrettyNumber (x) {
  return Number(x).toLocaleString()
}
